var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgamhubHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 14.875H23.375V12.2188C23.375 11.9255 23.1375 11.6875 22.8438 11.6875H14.875V9.5625H19.6562C19.95 9.5625 20.1875 9.3245 20.1875 9.03125V0.53125C20.1875 0.238 19.95 0 19.6562 0H9.03125C8.738 0 8.5 0.238 8.5 0.53125V9.03125C8.5 9.3245 8.738 9.5625 9.03125 9.5625H13.8125V11.6875H5.84375C5.5505 11.6875 5.3125 11.9255 5.3125 12.2188V14.875H0.53125C0.238 14.875 0 15.1125 0 15.4062V23.9062C0 24.2 0.238 24.4375 0.53125 24.4375H11.1562C11.4495 24.4375 11.6875 24.2 11.6875 23.9062V15.4062C11.6875 15.1125 11.4495 14.875 11.1562 14.875H6.375V12.75H22.3125V14.875H17.5312C17.2375 14.875 17 15.1125 17 15.4062V23.9062C17 24.2 17.2375 24.4375 17.5312 24.4375H28.1562C28.45 24.4375 28.6875 24.2 28.6875 23.9062V15.4062C28.6875 15.1125 28.45 14.875 28.1562 14.875Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgamhubHover);
export default __webpack_public_path__ + "static/media/progamhubHover.9191f9c0021b884ab91bdcb48091dd50.svg";
export { ForwardRef as ReactComponent };